// extracted by mini-css-extract-plugin
module.exports = {"disabledScreen":"disabledScreen__2JDL_","disabledMessage":"disabledMessage__9tn17"};